import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PracticeGame from "../../components/PracticeGameKS1";
import Calculator from "../../components/GenericCalculator";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { Scale } from 'react-scaling';
import axios from "axios";
import { navigate } from "@reach/router";//this is for the back button
import { ContactSupportOutlined } from "@material-ui/icons";

import {Button} from "../../../../globals/components/button";

import myData from '../../assets/KS1/KS1Questions.json';
import bg1 from '../../assets/KS1/ROUND1BG.gif';
import bg2 from '../../assets/KS1/ROUND2BG.png';
import bg3 from '../../assets/KS1/ROUND3BG.png';
import bg4 from '../../assets/KS1/ROUND4BG.gif';
import bg5 from '../../assets/KS1/menu_ks1.gif';

//import useAuth from "../../../auth/hooks/useAuth";

var { questions } = [];
var currQuestion;


//used for smart allocation - refeed
var refeedQuestions = [];
var repeating = false;
var lastWord = "";
var questionCounter = 0;

//Liam - used to make timer be called and cancelled, wordTime is var for finding question time
var wordTime = 0;
let addWordTimeout;

let ratingMode = false;



export default function Game({ ...props }) {
   // const { state: authState } = useAuth();
    const [loading, setLoading] = useState(true);
    const [correctQuestions, setCorrectQuestions] = useState([]);
    const [incorrectQuestions, setIncorrectQuestions] = useState([]);
    const [score, setScore] = useState(0);
    const [combo, setCombo] = useState(0);
    const [maxCombo, setMaxCombo] = useState(0);
    const [feedback, setFeedback] = useState([]);
    const [nofeedback, setNoFeedback] = useState([]);
    const [status, setStatus] = useState("LOADING");
    const [setup, setSetup] = useState(false);
    const [custom, setCustom] = useState(false);

    const [currentLevel, setCurrentLevel] = useState(1);//0-5
    const [questionNum, setQuestionNum] = useState(1);
    const [roundQuestionNum, setRoundQuestionNum] = useState(1);
    const [levelScreen, setLevelScreen] = useState(false);
    const [endgame, setEndgame] = useState(false);
    const [roundCorrect, setRoundCorrect]= useState(0);
    const [remainingQuestions, setRemainingQuestions] = useState(
        props.timer ? props.timer : 5
    );

    console.log("tst: hi: " + custom);
   
    var timer = -1;

    //var questionMax = 10;


    //console.log(props);
    if (setup == false) {
        questions = undefined;
        if (questions == undefined && props.customlist == undefined && setup == false) {
            //sets it to rating mode if pressed the rating mode button
            if (props.ratingMode == undefined){
                ratingMode = false;
            }else{
                ratingMode = true;
            }
                    questions = myData;
                    //check questions stuff setting the level
                    setCurrentLevel(1);
                    setQuestionNum(1);
                    setStatus("OK");
                    //console.log(response);
                    console.log(questions);
                    //console.log(status);
            
            setCustom(false);
            setSetup(true);
        } else if (setup == false && props.customlist != undefined) {
            questions = [];
            var list = props.customlist;
            setStatus("OK");
            setCustom(true);
            setSetup(true);
        }
    }

    const { sayWord } = useSpeech();
    const [currentQuestion, setCurrentQuestion] = useState([]);
    const [wordToSay, setWordToSay] = useState("");
    const [extraChars, setExtraChars] = useState([]);

    function GenerateRandom(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      }


    function newQuestion() {
        clearTimeout(addWordTimeout);
        let getNewQuestion = true;

        let availableQuestions = [];

        if (ratingMode == true){
            questions.questions.forEach(item => {
                if (item.Round.toString() == currentLevel.toString() && item.questnumber.toString() == questionNum.toString()){
                    availableQuestions.push(item);
                }
            });

        }else{
            let topics = props.topics;
            questions.questions.forEach(item => {
                topics.forEach(topic => {
                    if (item.Round.toString() == topic){
                        availableQuestions.push(item);
                    }
                });
            });
        }
        if (availableQuestions.length == 0){
            console.log(questionNum);
            console.log(currentLevel);
            console.log(availableQuestions);
        }
        console.log(availableQuestions);
        //get a random one
        currQuestion = availableQuestions[GenerateRandom(0,availableQuestions.length)];
        console.log(currQuestion);
        currQuestion.topic_key = "ks1_"+currQuestion.Subtopic;
        setCurrentQuestion(currQuestion);
        //set question text
        console.log(currQuestion);
    }

    //Liam - Get the length of the current word then times it by 2
    //times the total by 1000 to get timer in milliseconds - refeed
    function getLettersFromWord(currWord){
     wordTime = (currWord.length * 2) *1000;
	}

    //when time expires, add time to wrong answers list - refeed
    function addCurrWord(){
    var question = currQuestion;
   // console.log("tst: currQ: " + question);
    refeedQuestions.push(question);
    //console.log("tst: Pushed");
	}

    //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
    function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastWord = "";
        console.log("RESET");
    }

    function GoUpALevel(){
        //setQuestionNum(1);
        setRoundQuestionNum(1);
        setLevelScreen(true);
        let newlevel = currentLevel+1;
        setCurrentLevel(newlevel);
        console.log("Current level: " + currentLevel);
        console.log("questions length: " + questions.length);
        if (newlevel > 5){
            console.log("ENDGAME");
            setEndgame(true);
        }
        setRoundCorrect(0);

        //newQuestion();
    }

    function HideLevelScreen(){
        console.log("hidescreen");
        setRoundQuestionNum(1);
        //setQuestionNum(1);
        setLevelScreen(false);
    }

    useEffect(() => {
        if (levelScreen == false) {
            newQuestion();
            setTimeout(()=>{
                //newQuestion();
               }, 1000)
        }
    }, [levelScreen]);
    

    async function checkResult(value, callback) {
        if (ratingMode == true){
            setRoundQuestionNum(roundQuestionNum+1);
            setQuestionNum(questionNum+1);
        }else{
            if (roundQuestionNum+1 <= remainingQuestions){
                setRoundQuestionNum(roundQuestionNum+1);
                setQuestionNum(questionNum+1);
            }
        }
        
         //set the current question to the last question -refeed
        questionCounter = questionCounter + 1;
        console.log("check result");
        console.log(value);

        var addToArray = false;

        let isCorrect = true;
        if (value) {
            if (currentQuestion.Answer.toString() === value.toString()) {
                setRoundCorrect(roundCorrect+1);
                setCorrectQuestions([...correctQuestions, currentQuestion]);
                isCorrect = true;
                let multiplier = combo > 0 ? combo + 1 : 1;
                multiplier = multiplier > 5 ? 5 : multiplier;
                setScore(score + multiplier * 10);
                setCombo(combo + 1);

                //check if refeed question is current
                //else is used to make it work, don't want to risk deleting in case it breaks something
                //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
                if (repeating) {
                    refeedQuestions.pop();
                    repeating = false;
                }
                else{
                    repeating = false;        
				}

                if (combo > maxCombo) {
                    setMaxCombo(combo);
                }
                let result = {
                    question: currentQuestion.Question,
                    correct: currentQuestion.Answer,
                    incorrect: value
                };
                setNoFeedback([...nofeedback, result]);
            } else {
                setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
                isCorrect = false;
                questionCounter = 0;
        
                if (combo === 0 && score >= 10) {
                    setScore(score - 10);
                } else {
                    setCombo(0);
                }
                let result = {
                    question: currentQuestion.Question,
                    correct: currentQuestion.Answer,
                    incorrect: value
                };
                setFeedback([...feedback, result]);
            }

            if (callback) {
                await callback(isCorrect).then(() => {
                    CheckLevel();
                });
            } else {
                CheckLevel();
            }
        }
    }

    function CheckLevel(){
        if (roundQuestionNum >= 5 && ratingMode == true){
            if (roundCorrect >= 3)
                GoUpALevel();
            else
                setEndgame(true);
        }else if (ratingMode == true){
            newQuestion();
        }else if (ratingMode == false){
            if (roundQuestionNum >= remainingQuestions){
                console.log("ENDGAME");
                setEndgame(true);
            }else{
                newQuestion();
            }
        }
    }

    
    
    useEffect(() => {
        if (status !== undefined && status === "OK") {
            console.log("status");
            console.log(questions);
            newQuestion();
            
            setLoading(false);
        }
    }, [status]);

    

    

    function ComboImage() {
        if (currentLevel == 1){
            return bg1;
        }else if (currentLevel == 2){
            return bg2;
        }else if (currentLevel == 3){
            return bg3;
        }else if (currentLevel == 4){
            return bg4;
        }else{
            return bg5;
        }
    }


    useEffect(() => {
        console.log("SHOULD DO TTS");
        if (wordToSay != null && wordToSay != undefined){
            sayWord(wordToSay);
        }
    }, [wordToSay]);

    function ChangeWord(word){
        setWordToSay(" ");
        console.log("I am changing the word");
        setWordToSay(word + " ");
    }

    function GoBack(){
        if (props.eventscreen == undefined){
            navigate("/games/39")
          }else{
            navigate("/games")
            //navigate("/war")
          }
    }

    console.log(props);

    return (
        <>
            <PracticeGame
                gameData={props.gameData}
                eventscreen={props.eventscreen}
                parent={props}
                correct={correctQuestions}
                incorrect={incorrectQuestions}
                endgame={endgame}
                score={score}
                defaultTimer={1}
                questionLimit={remainingQuestions}
                onBack={() => {
                    GoBack()
                }}
                ratingMode={ratingMode}
                loading={loading}
                feedback={feedback}
                nofeedback={nofeedback}
                questionFontSize="0.7em"
                custom={custom}
                questionNum={questionNum}
                dontShowQNum={true}
                increaselevel={() => {
                    console.log("removed");
                }}
                restart={() => {
                    setCombo(0);
                    setScore(0);
                    setCorrectQuestions([]);
                    setIncorrectQuestions([]);
                    clearTimeout(addWordTimeout);
                    Reset();
                }}
                homework_id={props.homework_id}
            >
                <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
                    <Scale scaleTo={1720}>
                        <Body>
            {levelScreen == true ? (
                <div>
                   {endgame == true ? (
                        <div style={{width: "150%"}}>
                            <h1>Looks like our journey ends here, thanks for playing!</h1>
                            <Button>
                                Quit
                            </Button>
                            <GreenButton>
                                Feedback
                            </GreenButton>
                        </div>
                   ):(
                    <div>
                        <div>
                            <h1>Congratulations on completing the round, press start to begin the next round</h1>
                            <Button
                            onClick={() => {
                                HideLevelScreen();
                            }}>
                                Start
                            </Button>
                            </div>
                    </div>
                   )}
                </div>
                
            ):(
                    <div>
                            {currentQuestion !== undefined &&
                                <div>
                                  <Calculator
                            onSubmitted={checkResult}
                            question={currentQuestion.Question}
                            answer={currentQuestion.Answer}
                            />
                            </div>
                            }
                    </div>
            )}
                        </Body>
                    </Scale>
                </div>
            </PracticeGame>
        </>
    );
}

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url("${props => props.gameBackground}");
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 100px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
    margin-left: 50px;
`;

const GreenButton = styled.button`
  background: rgb(25, 160, 63);
  background: linear-gradient(
    0deg,
    rgba(25, 160, 63, 1) 0%,
    rgba(43, 196, 86, 1) 100%
  );
  width: 100%;
  border: 2px solid rgb(25, 160, 63);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 1em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 10px;
  }
`;
